// Copyright (c) 2020-2023 Omics Data Automation, Inc.
// Copyright (c) 2023 datma, inc.
//
// Proprietary and Confidential:
// Unauthorized copying of this file by any medium is strictly prohibited.

import { store } from '@/store'
import { fetchWithTimeout } from '@/common/shared'
import { tumorBoardBaseUrl } from '@/settings'

export const putTumorBoard = async (data) => {
  try {
    const fetchParams = {
      method: 'PUT',
      headers: {
        Authorization: 'Bearer ' + store.getters.jwt,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    }
    const url = `${tumorBoardBaseUrl}/api/v2/tumorboards`
    const response = await fetchWithTimeout(url, fetchParams)
    const result = await response.json()
    if (!response.ok) {
      console.log(`error: status=${response.status}`)
      return result
    }
    if (!result) {
      return []
    }
    // Translate the response to the format expected by the frontend.
    return result
  } catch (e) {
    if (e.name === 'AbortError') {
      console.log('timeout error')
    } else {
      console.log('ERROR:', e)
    }
  }
  return []
}
